import { customElement } from '@aurelia/runtime-html';
import * as __au2ViewDef from './toolbar-container.html';
import {Logger} from "resources/services/logger";
import {BackendService} from "../../resources/services/backend-service";
import {SelectedObjectService} from "../../resources/services/selected-object";
import {EventAggregator, inject} from "aurelia";
import {UserService} from "../../resources/services/user-service";

@customElement(__au2ViewDef)
@inject(EventAggregator)
export class ToolbarContainer {
    constructor(
        private logger: Logger,
        private selectedObjectService: SelectedObjectService,
        private backendService: BackendService,
        private userService: UserService,
        private eventAggregator: EventAggregator,
    ) {
    }

    attached() {
        window.addEventListener("keydown", this.handleKeyDown.bind(this));
    }

    detaching() {
        window.removeEventListener("keydown", this.handleKeyDown.bind(this));
    }

    handleKeyDown(event) {
        if (event.ctrlKey && event.key === "s") {
            event.preventDefault(); // Prevents the default browser behavior for Ctrl+S
            this.save();
        }
    }

    undo() {
        this.logger.log("undo", "info");
    }

    redo() {
        this.logger.log("redo", "info");
    }

    async test() {
        console.log(
            "Currently selected object : ",
            this.selectedObjectService.selectedObject,
        );
    }

    refresh() {
        this.eventAggregator.publish("refresh", "Refresh button");
    }

    async save() {
        await this.backendService.saveSelectedObject();
        this.eventAggregator.publish("refresh", "Save");
    }
}

    import { Metadata as $$M } from '@aurelia/metadata';
    import { ExpressionKind as $$EK } from '@aurelia/runtime';
    import { Controller as $$C, CustomElement as $$CE, IHydrationContext as $$IHC } from '@aurelia/runtime-html';

    // @ts-ignore
    const controllers = [];

    // @ts-ignore
    if (module.hot) {

    // @ts-ignore
    module.hot.accept();

    // @ts-ignore
    const hot = module.hot;

    let aurelia = hot.data?.aurelia;

    // @ts-ignore
    document.addEventListener('au-started', (event) => {aurelia= event.detail; });
    const currentClassType = ToolbarContainer;

    // @ts-ignore
    const proto = ToolbarContainer.prototype

    // @ts-ignore
    const ogCreated = proto ? proto.created : undefined;

    if (proto) {
      // @ts-ignore
      proto.created = function(controller) {
        // @ts-ignore
        ogCreated && ogCreated.call(this, controller);
        controllers.push(controller);
      }
    }

    // @ts-ignore
    hot.dispose(function (data) {
      // @ts-ignore
      data.controllers = controllers;
      data.aurelia = aurelia;
    });

    if (hot.data?.aurelia) {
      const newDefinition = $$CE.getDefinition(currentClassType);
      $$M.define(newDefinition.name, newDefinition, currentClassType);
      $$M.define(newDefinition.name, newDefinition, newDefinition);
      hot.data.aurelia.container.res[$$CE.keyFrom(newDefinition.name)] = newDefinition;

      const previousControllers = hot.data.controllers ?? [];
      if(previousControllers.length === 0) {
        // @ts-ignore
        hot.invalidate?.();
      }

      // @ts-ignore
      previousControllers.forEach(controller => {
        const values = { ...controller.viewModel };
        const hydrationContext = controller.container.get($$IHC)
        const hydrationInst = hydrationContext.instruction;

        const bindableNames = Object.keys(controller.definition.bindables);
        // @ts-ignore
        Object.keys(values).forEach(key => {
          if (bindableNames.includes(key)) {
            return;
          }
          // if there' some bindings that target the existing property
          // @ts-ignore
          const isTargettedByBinding = controller.bindings?.some(y =>
            y.ast?.$kind === $$EK.AccessScope
              && y.ast.name === key && y.targetProperty
          );
          if (!isTargettedByBinding) {
            delete values[key];
          }
        });
        const h = controller.host;
        delete controller._compiledDef;
        controller.viewModel = controller.container.invoke(currentClassType);
        controller.definition = newDefinition;
        Object.assign(controller.viewModel, values);
        if (controller._hydrateCustomElement) {
          controller._hydrateCustomElement(hydrationInst, hydrationContext);
        } else {
          controller.hE(hydrationInst, hydrationContext);
        }
        h.parentNode.replaceChild(controller.host, h);
        controller.hostController = null;
        controller.deactivate(controller, controller.parent ?? null, 0);
        controller.activate(controller, controller.parent ?? null, 0);
      });
    }
  }